import './Input.scss';
import React, { FC, ReactNode, KeyboardEvent, ChangeEvent, FocusEvent } from 'react';
import TypedMessage from "../../atoms/TypedMessage/TypedMessage";

interface IInput {
    className?: string;
    name: string;
    type?: "text" | "password" | "email";
    placeholder: string;
    ErrorMessage?: ReactNode;
    message?: any;
    onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
    value?: string;
    innerRef?: any;
    error?: boolean;
}

const Input: FC<IInput> = ({
                               innerRef,
                               name,
                               className = "",
                               type = "text",
                               placeholder,
                               onBlur,
                               onKeyDown = () => {},
                               onChange,
                               value,
                               message = "",
                               ErrorMessage,
                               error
                           }) => {
    return (
        <>
            <div className={`input ${error ? 'error' : ''} ${className}`}>
                <label>
                    <input
                        onKeyDown={onKeyDown}
                        autoComplete={'off'}
                        ref={innerRef}
                        placeholder={' '} // Пробел нужен для работы селектора :not(:placeholder-shown)
                        type={type}
                        onChange={onChange}
                        onBlur={onBlur}
                        name={name}
                        value={value}
                    />
                    <span className="input__label">{placeholder}</span>
                    <div className={`input__message ${message !== "" ? "active" : ""}`}>
                        {message !== "" && (
                            <TypedMessage
                                cursor={false}
                                loop={false}
                                className={'input__message-text'}
                                strings={[message]}
                            />
                        )}
                    </div>
                </label>
            </div>
            {ErrorMessage && <p style={{ color: "#DB3522", fontSize: "12px", marginTop: "4px" }}>{ErrorMessage}</p>}
        </>
    );
};

export default Input;